$( ( $ ) => {
  const btnGotoTop = '<button class="goto-top">top</button>';
  const insightContent = $( '.bs-section--insight-inner-content' );
  const notificationBarWrapper = $( '.notification-top-bar__wrapper' );

  if( insightContent.length ) {
    const options = {
      threshold: 0,
      rootMargin: '-150px',
    };

    const scrollHandler = () => {
      $( '.goto-top' ).on( 'click', function(){
        const notificationBarWrapperHeight = $( notificationBarWrapper ).height();
        const insightContentCoords = $( insightContent )[0]?.getBoundingClientRect();
        window.scrollTo(
          {
            left: insightContentCoords.left + window.scrollX,
            top: insightContentCoords.top + window.scrollY - 80 - notificationBarWrapperHeight,
            behavior: 'smooth',
          }
        );
      } );
    };
    
    const observer = new IntersectionObserver( 
      entries => {
        entries.forEach( entry => {
          $( '.goto-top' ).toggleClass( 'show', entry.isIntersecting );
          scrollHandler();
        } );
      }, options
    ); 
    observer.observe( $( '.bs-section--insight-inner-content .bs-column:last-of-type' )[0] );

    $( 'main' ).prepend( btnGotoTop ); 
  }
} );
